import * as React from 'react';
// tslint:disable-next-line: match-default-export-name
import cx from 'classnames';

import * as styles from './styles.css';

// tslint:disable-next-line: max-line-length
export interface ITabProps
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  active?: boolean;
}

export const Tab = ({ active, ...props }: ITabProps) => (
  <button {...props} className={cx(props.className, styles['tab'], active && styles['active'])} type="button" />
);
